interface Props {
  size: number;
}

export function SizeBadge({ size }: Props) {
  const displaySize = size < 25 ? 'S' : size < 50 ? 'M' : size < 75 ? 'L' : 'XL';
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 text-xs font-medium rounded bg-bg-subtle text-text-secondary">
      {displaySize}
    </span>
  );
}
